@if (showAsDialog) {
  <div class="modal-header"><h2 class="modal-title">Minutes</h2></div>
}
<div class="page-content page-fill">
  @if (!showAsDialog) {
    <div class="mb-2">
      <strong>
        The Documents tab serves as a secure repository intended exclusively for the <u>Chair and Clerk of Council</u>, housing sensitive materials NOT designated for automatic
        distribution to the Full Council.
      </strong>
    </div>
  }
  <div class="d-flex">
    <dx-file-uploader
      name="fileUpload"
      selectButtonText="Select File(s)"
      class="attachments"
      accept="*"
      uploadMode="instantly"
      [showFileList]="false"
      [multiple]="true"
      [uploadUrl]="serviceName + '/api/utility/uploadCommitteeAttachment/' + committeeId"
      [uploadHeaders]="uploadHeaders"
      (onUploadStarted)="uploadStarted($event)"
      (onUploadError)="uploadError($event)"
      (onUploaded)="uploaded($event)"
      >
    </dx-file-uploader>
  </div>
  @if (documents) {
    <div class="grid-fill reconciliation-data-grid" [ngStyle]="{ 'min-height': showAsDialog ? '700px' : '100%', 'max-width': '99%' }">
      <dx-data-grid
        #dataGrid
        keyExpr="id"
        [dataSource]="documents"
        [showBorders]="true"
        [columnAutoWidth]="false"
        [focusedRowEnabled]="false"
        [showColumnLines]="true"
        [wordWrapEnabled]="true"
        (onToolbarPreparing)="onToolbarPreparing($event)"
        (onSelectionChanged)="onSelectionChanged($event)"
        (onCellDblClick)="rowDoubleClick($event)"
        (onRowPrepared)="rowPrepare($event)"
        >
        <dxi-column dataField="created" caption="Date" dataType="date" width="100" [sortIndex]="1" [sortOrder]="'desc'"></dxi-column>
        <dxi-column dataField="committee.name" caption="Committee" width="120"></dxi-column>
        <dxi-column dataField="typeName" width="100"></dxi-column>
        <dxi-column dataField="name" width="500"></dxi-column>
        <dxo-state-storing [enabled]="true" type="localStorage" storageKey="doc-list-grid"></dxo-state-storing>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-search-panel [visible]="true"></dxo-search-panel>
        <dxo-selection [mode]="'multiple'" [showCheckBoxesMode]="'onClick'"></dxo-selection>
        <div *dxTemplate="let data of 'toolbarButtons'">
          @if (!reviewOnly && !showAsDialog) {
            <button
              (click)="rename()"
              class="btn btn-sm btn-secondary ms-4"
              [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
              >
              Edit Name
            </button>
          }
          @if (!reviewOnly && !showAsDialog) {
            <button
              (click)="email()"
              class="btn btn-sm btn-primary ms-2"
              [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
              >
              Email
            </button>
          }
          @if (!reviewOnly && !showAsDialog) {
            <button
              (click)="delete()"
              class="btn btn-sm btn-danger ms-2"
              [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
              >
              Delete
            </button>
          }
        </div>
        <div *dxTemplate="let data of 'toolbarText'">
          @if (documents) {
            <span class="me-3">
              <strong>{{ dataGrid.instance.totalCount() + " items" }} </strong>
            </span>
          }
          @if (documents) {
            <span class="me-3">
              <strong>
                {{ dataGrid.instance.getSelectedRowsData().length > 0 ? dataGrid.instance.getSelectedRowsData().length + " selected" : "0 selected" }}
              </strong>
            </span>
          }
        </div>
      </dx-data-grid>
    </div>
  }
</div>
@if (showAsDialog) {
  <div class="modal-footer">
    <button class="btn btn-success" [disabled]="processing" (click)="save()">Save</button>
    <button class="btn btn-secondary" (click)="cancel()">Cancel</button>
  </div>
}
